/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteIcon24Solid = forwardRef('CertRosetteIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.95 9.617a4.051 4.051 0 1 1 8.102 0 4.051 4.051 0 0 1-8.103 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.867 9.625c0 2.09.79 3.997 2.087 5.436l-2.18 3.114a1.5 1.5 0 0 0 .368 2.089l3.084 2.159a1.5 1.5 0 0 0 2.089-.368l2.682-3.831 2.683 3.83a1.5 1.5 0 0 0 2.09.369l3.082-2.159a1.5 1.5 0 0 0 .369-2.09l-2.185-3.119a8.125 8.125 0 1 0-14.169-5.43ZM12 4.065a5.551 5.551 0 1 0 0 11.103 5.551 5.551 0 0 0 0-11.102Z" })));
});
